class ESRModal extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
    this.isOpen = false;
    this._hasMovedToBody = false;
    this.isNoTitle = this.title === '';
    this.render();
  }

  static get observedAttributes() {
    return ['title', 'width', 'append-to-body', 'z-index'];
  }

  connectedCallback() {
    const appendToBody = this.getAttribute('append-to-body') === 'true';

    if (appendToBody && !this._hasMovedToBody && this.parentElement !== document.body) {
      this._hasMovedToBody = true;
      document.body.appendChild(this);
    }
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (!this.shadowRoot) return;

    if (name === 'title') {
      const titleEl = this.shadowRoot.querySelector('.modal__title');
      if (titleEl) {
        if (typeof newValue === 'string' && newValue.includes('<br')) {
          titleEl.innerHTML = newValue;
        } else {
          titleEl.textContent = newValue;
        }
        titleEl.textContent = newValue;
      }
    }

    if (name === 'width') {
      this.updateWidth();
    }

    if (name === 'z-index') {
      this.updateZIndex();
    }
  }

  updateZIndex() {
    const modal = this.shadowRoot.querySelector('.modal');
    const overlay = this.shadowRoot.querySelector('.modal-overlay');
    if (modal && overlay) {
      const zIndex = this.getAttribute('z-index') || '9000000';
      overlay.style.zIndex = zIndex;
      modal.style.zIndex = parseInt(zIndex) + 1;
    }
  }

  updateWidth() {
    const modal = this.shadowRoot.querySelector('.modal');
    if (modal) {
      const width = this.getAttribute('width') || '400px';

      // 移动端下，宽度为 90%
      detectMobile(({ isMobile }) => {
        if (isMobile) {
          modal.style.width = '94%';
        } else {
          modal.style.width = width;
        }
      });
    }
  }

  render() {
    const style = `
      <style>
        .modal-overlay {
          display: none;
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.75);
          z-index: ${this.getAttribute('z-index') || '9000000'};
        }

        .modal {
          position: fixed;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          background: #fff;
          border-radius: 12px;
          width: ${this.getAttribute('width') || '400px'};
          max-width: 94%;
          max-height: 90vh;
          z-index: ${parseInt(this.getAttribute('z-index') || '9000000') + 1};
          display: none;
          flex-direction: column;
        }

        .modal__header {
          padding: 24px;
          border-bottom: 1px solid #eee;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .modal__title {
          font-size: 20px;
          font-weight: 600;
          color: #3D3D3D;
          margin: 0;
        }

        .modal__close {
          width: 24px;
          height: 24px;
          border: none;
          background: none;
          cursor: pointer;
          padding: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          background-image: url('https://cdn.shopify.com/s/files/1/0694/0242/7619/files/support-close.png?v=1744868342');
          background-repeat: no-repeat;
          background-size: cover;
        }
        .modal__close.no--title{
          position: absolute;
          right: 24px;
          top: 24px;
          z-index:1;
        }
        .modal__close svg {
          width: 24px;
          height: 24px;
          color: #999;
          transition: color 0.2s;
          display: none;
        }

        .modal__close:hover svg {
          color: #333;
        }

        .modal__content {
          padding: 24px;
          overflow-y: auto;
        }

        .modal.open,
        .modal-overlay.open {
          display: flex;
        }

        /* 动画效果 */
        .modal {
          opacity: 0;
          transform: translate(-50%, -48%);
          transition: all 0.3s ease-out;
        }

        .modal.open {
          opacity: 1;
          transform: translate(-50%, -48%);
        }

        .modal-overlay {
          opacity: 0;
          transition: opacity 0.3s ease-out;
        }

        .modal-overlay.open {
          opacity: 1;
        }
        :host(#pop-utm-modal.warranty) .modal__content{
          padding-top: 0;
          padding-left: 0;
          padding-right: 0;
          padding-bottom: 0;
          border-radius: 15px;
        }
        :host(#pop-utm-modal.warranty) .modal__close.no--title{
          right: 14px;
          top: 14px;
        }
        :host(#pop-utm-modal.warranty) .modal__close{
          width: 28px;
          height: 28px;
        }
        :host(#pop-utm-modal.warranty) .modal.open{
          background: transparent;
        }

        @media screen and (max-width: 768px) {
          .modal {
            width: ${this.getAttribute('width') || '90%'};
          }

          .modal__header {
            padding: 20px;
          }

          .modal__content {
            padding: 20px;
          }
        }
      </style>
    `;

    const closeIcon = `
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    `;
    const closeBtn = this.isNoTitle
      ? `<button class="modal__close no--title" aria-label="Close modal">
                ${closeIcon}
              </button>`
      : `<button class="modal__close" aria-label="Close modal">
                ${closeIcon}
              </button>`;
    const header = !this.isNoTitle
      ? `<div class="modal__header">
            <h2 class="modal__title">${this.getAttribute('title') || ''}</h2>
           ${closeBtn}
            </div>
          `
      : '';

    this.shadowRoot.innerHTML = `
      ${style}
      <div class="modal-overlay">
        <div class="modal">
          ${header}
          <div class="modal__content">
            ${this.isNoTitle ? closeBtn : ''}
            <slot></slot>
          </div>
        </div>
      </div>
    `;

    this.setupEventListeners();
  }

  setupEventListeners() {
    const closeBtn = this.shadowRoot.querySelector('.modal__close');
    closeBtn.addEventListener('click', () => this.close());

    const content = this.shadowRoot.querySelector('.modal__content');
    content.addEventListener('click', (e) => {
      const closeModalBtn = e.target.closest('[data-close-modal]');
      if (closeModalBtn) {
        this.close();
      }
    });
  }

  open() {
    if (this.isOpen) return;

    this.isOpen = true;
    const overlay = this.shadowRoot.querySelector('.modal-overlay');
    const modal = this.shadowRoot.querySelector('.modal');

    requestAnimationFrame(() => {
      overlay.classList.add('open');
      modal.classList.add('open');
    });

    document.body.style.overflow = 'hidden';
    this.dispatchEvent(
      new CustomEvent('modal:open', {
        bubbles: true,
        composed: true,
      })
    );
  }

  close() {
    if (!this.isOpen) return;

    this.isOpen = false;
    const overlay = this.shadowRoot.querySelector('.modal-overlay');
    const modal = this.shadowRoot.querySelector('.modal');

    overlay.classList.remove('open');
    modal.classList.remove('open');

    document.body.style.overflow = '';
    this.dispatchEvent(
      new CustomEvent('modal:close', {
        bubbles: true,
        composed: true,
      })
    );
  }
}

customElements.define('esr-modal', ESRModal);
